import { render, staticRenderFns } from "./socket.vue?vue&type=template&id=1f867d56&scoped=true"
import script from "./socket.vue?vue&type=script&lang=js"
export * from "./socket.vue?vue&type=script&lang=js"
import style0 from "./socket.vue?vue&type=style&index=0&id=1f867d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f867d56",
  null
  
)

export default component.exports